import { useAssessmentPopupStore } from '@/stores/assessmentPopupState'
import { getAnalysisModeUrl } from '@/helpers/integrations'

export function openAnalysisPopup(
  playerId: string,
  playerEmail?: string,
  onCloseCallback?: () => void
) {
  const store = useAssessmentPopupStore()

  store.show({
    playerId,
    playerEmail,
    url: 'story',
    slide: undefined
  })

  if (onCloseCallback) {
    const unsubscribe = store.$subscribe((mutation, state) => {
      if (!state.isVisible && !state.showExitAssessment && !state.showInitialAssessment) {
        onCloseCallback()
        unsubscribe()
      }
    })
  }
}

export function getAnalysisModeUrlUtil(
  mode: 'fullPage' | 'popup',
  playerId: string,
  platform: 'desktop' | 'mobile',
  playerEmail?: string,
  path?: string,
  slide?: number
) {
  const url = getAnalysisModeUrl()
  const pathSegment = path ? `/${path}` : ''
  const platformParam = platform ? `&platform=${platform}` : ''
  const emailParam = playerEmail ? `&playerEmail=${playerEmail}` : ''
  const queryParams = `?bg=transparent&mode=${mode}&playerId=${playerId}${emailParam}${platformParam}`
  const hash = slide ? `#page-${slide}` : ''

  return url + pathSegment + queryParams + hash
}
